module.exports = __webpack_public_path__ + "img/partner15.219fb3d5.png";